import type { RubroRemoveConfirmCopy } from '../rubroList/rubroRemoveConfirmCopy.ts'

export type BackToWelcomeConfirmVariant =
  | 'manual'
  | 'precargaPick'
  | 'precargaProcessing'
  | 'precargaEditor'

export function getBackToWelcomeConfirmCopy(
  variant: BackToWelcomeConfirmVariant
): RubroRemoveConfirmCopy {
  if (variant === 'precargaPick') {
    return {
      title: '¿Volver al inicio?',
      body:
        'Ya elegiste archivos o avanzaste en la precarga con IA, pero todavía no hay un borrador listo para revisar. Si volvés al inicio se descarta esa selección.',
      confirmLabel: 'Volver al inicio',
      cancelLabel: 'Seguir en precarga'
    }
  }
  if (variant === 'precargaProcessing') {
    return {
      title: '¿Volver al inicio?',
      body:
        'Hay un análisis de documentación en curso. Si volvés al inicio se interrumpe el proceso y no se guarda el borrador que se estaba armando.',
      confirmLabel: 'Volver al inicio',
      cancelLabel: 'Seguir en precarga'
    }
  }
  if (variant === 'precargaEditor') {
    return {
      title: '¿Volver al inicio?',
      body:
        'El borrador con rubros, documentación y ventanas de cotización que generó la IA no se conserva si volvés al inicio. Tendrías que cargar los archivos de nuevo.',
      confirmLabel: 'Volver al inicio',
      cancelLabel: 'Seguir editando'
    }
  }
  return {
    title: '¿Volver al inicio?',
    body:
      'Los datos del proyecto y los rubros que cargaste en este borrador no se guardan. Si volvés al inicio empezás de cero.',
    confirmLabel: 'Volver al inicio',
    cancelLabel: 'Cancelar'
  }
}

export function resolveBackToWelcomeConfirmVariant(args: {
  isManualCreatePhase: boolean
  isAssistedPrecargaPhase: boolean
  precargaUiPhase: 'pick' | 'processing' | 'editor'
  hasManualCreateProgress: boolean
  precargaPickHasPendingWork: boolean
  precargaHasSeedFiles: boolean
}): BackToWelcomeConfirmVariant | null {
  const {
    isManualCreatePhase,
    isAssistedPrecargaPhase,
    precargaUiPhase,
    hasManualCreateProgress,
    precargaPickHasPendingWork,
    precargaHasSeedFiles
  } = args
  if (isAssistedPrecargaPhase) {
    if (precargaUiPhase === 'processing') return 'precargaProcessing'
    if (precargaUiPhase === 'editor') return 'precargaEditor'
    if (
      precargaUiPhase === 'pick' &&
      (precargaPickHasPendingWork || precargaHasSeedFiles)
    ) {
      return 'precargaPick'
    }
    return null
  }
  if (isManualCreatePhase && hasManualCreateProgress) return 'manual'
  return null
}
